import type { ReactElement } from 'react'
import type { ServiceId } from '@/content/services'

const INK = 'var(--icon-ink)'
const ACCENT = 'var(--icon-accent)'

const PATHS: Record<ServiceId, ReactElement> = {
  crm: (
    <>
      <rect x="4" y="12" width="26" height="26" rx="7" fill={INK} />
      <rect x="22" y="12" width="26" height="26" rx="7" fill={ACCENT} opacity=".85" />
    </>
  ),
  erp: (
    <>
      <rect x="4" y="6" width="44" height="10" rx="4" fill={INK} />
      <rect x="4" y="21" width="44" height="10" rx="4" fill={ACCENT} opacity=".85" />
      <rect x="4" y="36" width="44" height="10" rx="4" fill={INK} />
    </>
  ),
  processes: (
    <>
      <path
        d="M6 14 L18 26 L6 38"
        fill="none"
        stroke={INK}
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 14 L34 26 L22 38"
        fill="none"
        stroke={ACCENT}
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  finance: (
    <>
      <rect x="5" y="17" width="32" height="20" rx="4" fill={INK} />
      <circle cx="35" cy="27" r="11" fill={ACCENT} />
      <path d="M35 22 V32 M31 27 H39" stroke={INK} strokeWidth="3" strokeLinecap="round" />
    </>
  ),
  realEstate: (
    <>
      <circle cx="16" cy="17" r="10" fill="none" stroke={INK} strokeWidth="5" />
      <rect x="24" y="15" width="22" height="5" fill={ACCENT} />
      <rect x="40" y="20" width="5" height="9" fill={ACCENT} />
      <rect x="31" y="20" width="5" height="6" fill={ACCENT} />
    </>
  ),
  mobile: (
    <>
      <rect x="16" y="4" width="20" height="44" rx="5" fill={INK} />
      <rect x="19" y="10" width="14" height="24" fill={ACCENT} opacity=".85" />
      <circle cx="26" cy="42" r="3" fill={ACCENT} />
    </>
  ),
  hospitality: (
    <>
      <path d="M8 36 C8 24.4 15.6 16 26 16 C36.4 16 44 24.4 44 36 Z" fill={INK} />
      <circle cx="26" cy="11" r="4" fill={ACCENT} />
      <rect x="4" y="38" width="44" height="6" rx="3" fill={ACCENT} />
    </>
  ),
  web: (
    <>
      <rect x="4" y="8" width="44" height="34" rx="6" fill={INK} />
      <rect x="4" y="8" width="44" height="10" rx="6" fill={ACCENT} />
      <circle cx="12" cy="13" r="2" fill={INK} />
      <circle cx="18" cy="13" r="2" fill={INK} />
    </>
  ),
  reservations: (
    <>
      <rect x="6" y="10" width="40" height="34" rx="6" fill={INK} />
      <rect x="6" y="10" width="40" height="10" fill={ACCENT} />
      <path
        d="M17 32 L23 38 L36 24"
        fill="none"
        stroke={ACCENT}
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
  analytics: (
    <>
      <rect x="6" y="28" width="10" height="18" fill={INK} />
      <rect x="21" y="18" width="10" height="28" fill={ACCENT} />
      <rect x="36" y="8" width="10" height="38" fill={INK} />
    </>
  ),
  loyalty: (
    <>
      <path d="M26 6 L31 20 L46 20 L34 29 L39 44 L26 35 L13 44 L18 29 L6 20 L21 20 Z" fill={INK} />
      <circle cx="26" cy="23" r="6" fill={ACCENT} />
    </>
  ),
  marketing: (
    <>
      <rect x="4" y="12" width="40" height="30" rx="6" fill={INK} />
      <path
        d="M9 18 L24 29 L39 18"
        fill="none"
        stroke={ACCENT}
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="42" cy="12" r="7" fill={ACCENT} />
    </>
  ),
  communication: (
    <>
      <path
        d="M10 30 V25 C10 15.6 17.2 8 26 8 C34.8 8 42 15.6 42 25 V30"
        fill="none"
        stroke={INK}
        strokeWidth="5"
        strokeLinecap="round"
      />
      <rect x="5" y="25" width="11" height="16" rx="4" fill={ACCENT} />
      <rect x="36" y="25" width="11" height="16" rx="4" fill={ACCENT} />
      <path d="M41.5 41 C41.5 45 38 46.5 32 46.5" fill="none" stroke={INK} strokeWidth="4" />
      <rect x="22" y="42.5" width="11" height="8" rx="4" fill={INK} />
    </>
  ),
  warehouse: (
    <>
      <rect x="10" y="26" width="32" height="16" rx="4" fill={INK} />
      <rect x="14" y="10" width="24" height="16" rx="4" fill={ACCENT} />
    </>
  ),
  facility: (
    <>
      <rect x="10" y="18" width="32" height="28" fill={INK} />
      <path
        d="M6 20 L26 6 L46 20"
        fill="none"
        stroke={ACCENT}
        strokeWidth="6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="22" y="32" width="8" height="14" fill={ACCENT} />
    </>
  ),
  api: (
    <>
      <circle cx="20" cy="26" r="14" fill="none" stroke={INK} strokeWidth="5" />
      <circle cx="34" cy="26" r="14" fill="none" stroke={ACCENT} strokeWidth="5" />
    </>
  ),
  cloud: (
    <>
      <path
        d="M16 36 C8 36 5 26 14 24 C14 14 28 11 33 19 C42 16 48 26 43 32 C49 32 49 37 43 37 Z"
        fill={INK}
      />
      <rect x="14" y="37" width="30" height="6" fill={ACCENT} />
    </>
  ),
  microsoft: (
    <>
      <rect x="6" y="6" width="18" height="18" fill={INK} />
      <rect x="28" y="6" width="18" height="18" fill={ACCENT} />
      <rect x="6" y="28" width="18" height="18" fill={ACCENT} />
      <rect x="28" y="28" width="18" height="18" fill={INK} />
    </>
  ),
  security: (
    <>
      <path d="M26 4 L44 12 V24 C44 34 36 42 26 46 C16 42 8 34 8 24 V12 Z" fill={INK} />
      <path d="M26 4 L44 12 V24 C44 34 36 42 26 46 Z" fill={ACCENT} />
    </>
  ),
  custom: (
    <path
      d="M26 4 L31 12 L41 11 L40 21 L48 26 L40 31 L41 41 L31 40 L26 48 L21 40 L11 41 L12 31 L4 26 L12 21 L11 11 L21 12 Z"
      fill={INK}
    />
  ),
  training: (
    <>
      <path d="M6 14 L24 10 V40 L6 44 Z" fill={INK} />
      <path d="M46 14 L28 10 V40 L46 44 Z" fill={ACCENT} />
    </>
  ),
  support: (
    <>
      <rect x="10" y="6" width="32" height="40" rx="6" fill={ACCENT} />
      <path
        d="M18 26 L24 32 L36 18"
        stroke={INK}
        strokeWidth="5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  ),
}

interface ServiceIconProps {
  id: ServiceId
  size?: number
}

export function ServiceIcon({ id, size = 44 }: ServiceIconProps) {
  return (
    <svg
      className="service-icon"
      width={size}
      height={size}
      viewBox="0 0 52 52"
      role="presentation"
      focusable="false"
      aria-hidden="true"
    >
      {PATHS[id]}
    </svg>
  )
}
